export function randomString(length = 10) {
  const chars = "0123456789"; // ชุดตัวอักษรที่จะสุ่ม (ตามโค้ดเดิมของคุณ)
  let result = "";
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * chars.length);
    result += chars.substring(randomIndex, randomIndex + 1);
  }
  return result;
}

/**
 * ฟังก์ชันสำหรับแปลงข้อมูล Product รูปแบบใหม่ ให้เป็นโครงสร้าง Group ตาม Branch
 * @param {Object} rawData - ข้อมูล JSON ฉบับย่อจาก Laravel (response.data.data)
 * @returns {Object} - ข้อมูลที่จัดรูปแบบแล้ว
 */
export function formatProductBranchData(rawData) {
  // ตรวจสอบความปลอดภัยเบื้องต้น
  if (!rawData || !rawData.branches) return null;

  return {
    name: rawData.name,
    is_config: rawData.config,
    type: rawData.type,
    price: rawData.price,
    created_at: rawData.created_at,
    updated_at: rawData.updated_at,
    // 1. วนลูปตามสาขาของสินค้าแม่
    branches: rawData.branches.map(parentBranch => {
      // 2. ดึงข้อมูล Variants เฉพาะที่มีขายในสาขานี้
      const matchedVariants = rawData.variants.reduce((acc, variantData) => {
        // หา object สาขาของตัวลูก ที่ branch_id ตรงกับสาขาของตัวแม่
        const childBranch = variantData.branches.find(b => b.branch_id === parentBranch.branch_id);

        if (childBranch) {
          // ถ้ามีขายในสาขานี้ ก็หยิบมาใส่ Array
          acc.push({
            id: childBranch.id, // ID ของตาราง branch_products (ตัวลูก)
            branch_id: childBranch.branch_id,
            product_id: variantData.id,
            name: variantData.name,
            price: variantData.price,
            price_override: childBranch.price,
            is_custom_price: childBranch.price != '',
            is_active: childBranch.is_active,
            is_in_stock: childBranch.is_in_stock
          });
        }
        return acc;
      }, []);

      // 3. ประกอบร่างคืนเป็น Object ของสาขานั้นๆ พร้อมข้อมูล Variants
      return {
        id: parentBranch.id,
        branch_id: parentBranch.branch_id,
        name: parentBranch.name,
        code: parentBranch.code,
        price_override: parentBranch.price,
        is_custom_price: parentBranch.price != '',
        is_active: parentBranch.is_active,
        is_in_stock: parentBranch.is_in_stock,
        variants: matchedVariants // เอา variant ที่แมตช์แล้ว ยัดใส่ตรงนี้
      };
    })
  };
}
/**
 * แปลง rich text (description ของสินค้า ที่หน้าหลังบ้านบันทึกเป็น HTML จาก vue-editor)
 * ให้เป็นข้อความล้วนบรรทัดเดียว สำหรับโชว์ใต้ชื่อเมนูแล้ว clamp ด้วย CSS
 *
 * ถอดแท็กด้วย regex (ไม่ยัด innerHTML) — การ set innerHTML จะรัน `<img onerror>`
 * ที่แฝงมาในข้อความได้ ส่วน block tag/`<br>` แปลงเป็นช่องว่างก่อน ไม่งั้นคำท้ายบรรทัด
 * จะติดกับคำแรกของบรรทัดถัดไป
 */
export function stripHtml(html) {
  if (!html) return '';
  return String(html)
    .replace(/<(br|\/p|\/div|\/li|\/h[1-6])[^>]*>/gi, ' ')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#0?39;/gi, "'")
    .replace(/\s+/g, ' ')
    .trim();
}
